import { render, staticRenderFns } from "./SimulatorMessageBox.vue?vue&type=template&id=795bd7fa&scoped=true&"
import script from "./SimulatorMessageBox.vue?vue&type=script&lang=js&"
export * from "./SimulatorMessageBox.vue?vue&type=script&lang=js&"
import style0 from "./SimulatorMessageBox.vue?vue&type=style&index=0&id=795bd7fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795bd7fa",
  null
  
)

export default component.exports